// ─────────────────────────────────────────────────────────────
// MARKMAXO — EDITABLE CONTENT
// Everything below is a placeholder. Replace text, numbers,
// links and image paths with your real content anytime.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "MARKMAXO",
  owner: "Inder",
  tagline: "Creative Editor • Visual Designer • AI Content Creator",
  positioning: "Creative Studio & Digital Brand",
  heroTitle: ["Creative Visuals.", "Cinematic Stories."],
  heroSub:
    "I turn ideas into cinematic videos, reels, graphics and AI-powered visual experiences.",
  footerTagline: "Creative Editor • Visual Designer • AI Content Creator",
  email: "markmaxobusiness@gmail.com",
};

// Honest stat cards — no invented numbers. Update with real figures when ready.
export const STATS = [
  { label: "Video Editing" },
  { label: "Reels & Short-Form" },
  { label: "Visual Design" },
  { label: "AI Creative Work" },
];

export const SERVICES = [
  { icon: "FilmSlate", title: "Video Editing", desc: "Narrative-driven cuts, pacing and rhythm that hold attention from the first frame." },
  { icon: "DeviceMobile", title: "Reels & Short-Form Content", desc: "Scroll-stopping vertical edits engineered for reach, retention and replay." },
  { icon: "FrameCorners", title: "Graphic & Poster Design", desc: "Bold key art, posters and brand graphics with cinematic composition and typographic punch." },
  { icon: "Sparkle", title: "AI Visual Creation", desc: "AI-assisted imagery and concepts, art-directed with a human eye." },
  { icon: "MagicWand", title: "Cinematic Visual Effects", desc: "Seamless compositing, glows and grade work that elevate every frame." },
  { icon: "ShareNetwork", title: "Social Media Content", desc: "Platform-native content systems built to grow and engage real audiences." },
];

export const CATEGORIES = ["All", "Video", "Reels", "Graphics", "AI"];

// Shown while PROJECTS below is empty — honest "work in progress" cards, no fake content.
export const COMING_SOON = [
  { category: "Video", title: "Video Editing", icon: "FilmSlate", blurb: "New cinematic edits are being crafted — this space will showcase them soon." },
  { category: "Reels", title: "Reels & Short-Form", icon: "DeviceMobile", blurb: "Fresh short-form work is in the edit suite — dropping here soon." },
  { category: "Graphics", title: "Graphic & Poster Design", icon: "FrameCorners", blurb: "New poster and graphic work is on the canvas — arriving soon." },
  { category: "AI", title: "AI Visual Creation", icon: "Sparkle", blurb: "New AI-crafted visuals are being directed — revealed here soon." },
];

// ✏️ ADD YOUR REAL PROJECTS HERE. Copy this template per project:
// {
//   id: 1,
//   title: "Project Title",
//   category: "Video",              // Video | Reels | Graphics | AI
//   image: "/assets/my-thumb.jpg",  // thumbnail on the card and in the popup
//   video: "https://…/video.mp4",   // optional — .mp4 URL or YouTube link; the popup plays it
//   desc: "One-line description.",
// },
// While this list is empty, the Coming Soon cards above are shown instead.
export const PROJECTS = [];

export const PROCESS = [
  { step: "01", title: "Concept", desc: "Every project starts with the idea — mood, message and the feeling it should leave behind." },
  { step: "02", title: "Create", desc: "Raw footage, pixels and prompts become something tangible through focused craft." },
  { step: "03", title: "Refine", desc: "Frame by frame, pixel by pixel — polishing until it feels inevitable." },
  { step: "04", title: "Deliver", desc: "Final exports, on time, optimized for every platform it will live on." },
];

// ✏️ EDIT ME: replace each "#" with your real profile URL, e.g. "https://instagram.com/yourhandle"
// No real profiles are linked — "#" is a deliberate placeholder.
export const SOCIALS = [
  { name: "Facebook", url: "#", icon: "FacebookLogo" },
  { name: "Instagram", url: "#", icon: "InstagramLogo" },
  { name: "YouTube", url: "#", icon: "YoutubeLogo" },
  { name: "LinkedIn", url: "#", icon: "LinkedinLogo" },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Contact", href: "#contact" },
];
